import React, { CSSProperties, ReactNode } from "react"
import { twMerge } from "tailwind-merge"

interface Props {
  children?: ReactNode
  className?: string
  style?: CSSProperties
}

export const Table: React.FC<Props> = ({ children, className, style = {} }) => {
  return (
    <div className="overflow-auto border-2 border-legacy-blue w-full rounded-lg">
      <table style={style} className={twMerge("w-full border-collapse", className)}>
        {children}
      </table>
    </div>
  )
}

export const THead: React.FC<Props> = ({ children, className, style = {} }) => {
  return (
    <thead style={style} className={twMerge("border-b rounded border-legacy-blue", className)}>
      {children}
    </thead>
  )
}

export const TBody: React.FC<Props> = ({ children, className, style = {} }) => {
  return (
    <tbody style={style} className={twMerge("rounded", className)}>
      {children}
    </tbody>
  )
}

interface TrProps extends React.HTMLAttributes<HTMLTableRowElement> {
  hover?: boolean
}

export const Tr: React.FC<Props & TrProps> = (props) => {
  const { children, className, style = {}, hover = false, ...restProps } = props
  return (
    <tr
      style={style}
      className={twMerge(
        "rounded border-b last-of-type:border-b-0",
        className,
        hover && "hover:bg-legacy-blue/10",
      )}
      {...restProps}
    >
      {children}
    </tr>
  )
}

export const Th: React.FC<Props> = ({ children, className, style = {} }) => {
  return (
    <th style={style} className={twMerge(className, "p-1.5 text-start")}>
      {children}
    </th>
  )
}

type TdProps = React.TdHTMLAttributes<HTMLTableDataCellElement>
export const Td: React.FC<TdProps> = (props) => {
  const { children, className, style = {}, ...restProps } = props
  return (
    <td style={style} className={twMerge(className, "p-1.5 text-start")} {...restProps}>
      {children}
    </td>
  )
}
